/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'team-central.give-jira-kudos.created.description.flag': '现在，我们的 Workplace Experience 团队将“施展魔法”来处理礼品请求。✨',
  'team-central.give-jira-kudos.created.title.flag': '已创建称赞',
  'team-central.give-jira-kudos.creation.failed.description.flag': '已发送称赞，但因出错而无法发送礼品。请转到 <a>go/kudos</a> 并提交一个工作单。',
  'team-central.give-jira-kudos.creation.failed.title.flag': '无法发送礼品',
  'team-central.give-kudos.button': '给予称赞',
  'team-central.give-kudos.close-button.label': '关闭抽屉菜单',
  'team-central.give-kudos.confirm-close.title': '确认关闭',
  'team-central.give-kudos.created.description.flag': '您的称赞已发送。<a>查看称赞</a>',
  'team-central.give-kudos.created.title.flag': '已创建称赞',
  'team-central.give-kudos.success-icon.label': '成功',
  'team-central.give-kudos.unsaved.warning': '您所做的更改将不会保存。',
  'team-central.give-kudos.unsaved.warning.cancel': '取消',
  'team-central.give-kudos.unsaved.warning.close': '关闭'
};